export enum PopupStateEnum {
  CREATE = 1,
  EDIT = 2,
  COPY = 3,
}
export default { PopupStateEnum };
